module.exports = __webpack_public_path__ + "static/media/cross red.b04f564c.svg";